"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_workflow_service_client_js_1 = require("@synisys/idm-workflow-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var Observable_1 = require("rxjs/Observable");
var material_1 = require("@angular/material");
var subscription_manager_decorator_1 = require("../shared/subscription-manager.decorator");
var router_1 = require("@angular/router");
var confirm_popup_component_1 = require("../confirm-popup/confirm-popup.component");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var process_structure_dto_1 = require("@synisys/idm-workflow-service-client-js/api/model/process-structure.dto");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var import_export_dialog_component_1 = require("./dialogs/import-export-dialog.component");
var change_history_dialog_component_1 = require("./dialogs/change-history-dialog.component");
var services_1 = require("../services");
var WorkflowProcessManagementComponent = /** @class */ (function () {
    function WorkflowProcessManagementComponent(processService, kbService, messageService, router, route, popUpsService, dialog, languageService, currentLanguageProvider, cdRef) {
        this.processService = processService;
        this.kbService = kbService;
        this.messageService = messageService;
        this.router = router;
        this.route = route;
        this.popUpsService = popUpsService;
        this.dialog = dialog;
        this.languageService = languageService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.cdRef = cdRef;
        this.processesFiltered = [];
        this.metaCategories = null;
        this.metaCategoriesBySystemName = new Map();
        this.metaCategorySystemNameModel = null;
        this.excludeMetaCategories = new Map();
        this.searchProcess = '';
        this.ready = false;
        this.addProcessError = false;
        this.pleaseSelect = '...';
        this.DE_PREFIX = 'de';
        this.ME_PREFIX = 'me';
        this.SURVEY_PREFIX = 'survey';
        this._pageSize = 4;
        this.displayedColumnsHeader = ['mainEntity', 'modifiedBy', 'modifiedOn'];
        this.displayedColumns = ['mainEntity', 'modifiedBy', 'modifiedOn', 'action'];
        this.initialized = false;
        this.searchIsOpen = false;
    }
    Object.defineProperty(WorkflowProcessManagementComponent.prototype, "pageSize", {
        get: function () {
            return this._pageSize;
        },
        set: function (pageSize) {
            this._pageSize = pageSize;
        },
        enumerable: true,
        configurable: true
    });
    WorkflowProcessManagementComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.$sm = Observable_1.Observable.zip(this.languageService.getAvailableLanguages(), this.currentLanguageProvider.getCurrentLanguage(), this.getMessage('workflow_designer.please_select')).subscribe(function (res) {
            _this.languages = res[0];
            _this.currentLanguageId = res[1].getId();
            _this.pleaseSelect = res[2];
            _this.loadData();
        });
    };
    WorkflowProcessManagementComponent.prototype.ngAfterViewInit = function () {
        this.initialized = true;
        this.cdRef.detectChanges();
    };
    WorkflowProcessManagementComponent.prototype.updateWorkflowList = function () {
        this.dataSource = new material_1.MatTableDataSource(this.processesFiltered);
    };
    WorkflowProcessManagementComponent.prototype.loadData = function () {
        var _this = this;
        this.processService.getProcessesWithTrackInfo().then(function (response) {
            _this.processes = response;
            _this.excludeMetaCategories.clear();
            _this.processes.forEach(function (process) {
                _this.excludeMetaCategories.set(process.getCategorySystemName(), true);
            });
            _this.filterSearchUpdate();
            _this.ready = true;
        });
        this.metaCategories = [];
        this.addMetaCategories(this.DE_PREFIX).subscribe(function () {
            _this.addMetaCategories(_this.ME_PREFIX).subscribe(function () {
                _this.addMetaCategories(_this.SURVEY_PREFIX).subscribe();
            });
        });
    };
    WorkflowProcessManagementComponent.prototype.addMetaCategories = function (context) {
        var _this = this;
        return new Observable_1.Observable(function (complete) {
            _this.$sm[context + 'Subscription'] = _this.kbService.getMainEntityMetaCategories(context).take(1).subscribe(function (metaCategories) {
                console.log('Adding context categories: ', context, metaCategories);
                metaCategories.forEach(function (metaCategory) {
                    _this.metaCategories.push(metaCategory);
                    _this.metaCategoriesBySystemName.set(metaCategory.getSystemName(), metaCategory);
                });
                complete.next(true);
            });
        });
    };
    WorkflowProcessManagementComponent.prototype.createNewProcessDrawer = function () {
        this.metaCategorySystemNameModel = null;
        this.addProcessError = false;
        this.drawer.open();
    };
    WorkflowProcessManagementComponent.prototype.createNewProcess = function () {
        var _this = this;
        if (!this.metaCategorySystemNameModel) {
            this.addProcessError = true;
            return;
        }
        this.drawer.close();
        var process = new process_structure_dto_1.ProcessStructureDto(null, this.getMultilingualString(this.metaCategorySystemNameModel).toMap(), null, this.metaCategorySystemNameModel, null, null, [], [], {}, null);
        this.processService.save(process).then(function () {
            _this.loadData();
        });
    };
    WorkflowProcessManagementComponent.prototype.deleteProcess = function (processId) {
        var _this = this;
        var dialogConfig = new material_1.MatDialogConfig();
        dialogConfig.width = '450px';
        dialogConfig.data = {
            message: 'workflow_designer.remove_selected_process'
        };
        dialogConfig.id = 'confirm-popup-id';
        var dialogRef = this.dialog.open(confirm_popup_component_1.ConfirmPopup, dialogConfig);
        this.$sm.deleteProcessConfirmation = dialogRef.afterClosed().subscribe(function (answer) {
            if (answer) {
                _this.processService.delete(processId).then(function () {
                    _this.loadData();
                });
            }
        });
    };
    WorkflowProcessManagementComponent.prototype.importDiagram = function (processId) {
        var config = new material_1.MatDialogConfig();
        config.width = '450px';
        config.data = {
            processId: processId,
            type: 'import'
        };
        this.dialog.open(import_export_dialog_component_1.ImportExportDialogComponent, config);
    };
    WorkflowProcessManagementComponent.prototype.exportDiagram = function (processId) {
        var config = new material_1.MatDialogConfig();
        config.width = '450px';
        config.data = {
            processId: processId,
            type: 'export'
        };
        this.dialog.open(import_export_dialog_component_1.ImportExportDialogComponent, config);
    };
    WorkflowProcessManagementComponent.prototype.openProcessHistory = function (processId) {
        var config = new material_1.MatDialogConfig();
        config.width = '750px';
        config.data = {
            processId: processId,
        };
        this.dialog.open(change_history_dialog_component_1.ChangeHistoryDialogComponent, config);
    };
    WorkflowProcessManagementComponent.prototype.editWorkflow = function (processId) {
        this.router.navigate([processId], { relativeTo: this.route });
    };
    WorkflowProcessManagementComponent.prototype.getMultilingualString = function (name) {
        var out = new Map();
        this.languages.forEach(function (language) {
            out.set(language.getId(), name);
        });
        return new idm_crosscutting_concepts_frontend_1.MultilingualString(out);
    };
    WorkflowProcessManagementComponent.prototype.getMessage = function (key) {
        return this.messageService.getMessage(key);
    };
    WorkflowProcessManagementComponent.prototype.filterSearchUpdate = function () {
        var _this = this;
        var search = this.searchProcess.trim().toLowerCase();
        if (search) {
            this.processesFiltered = this.processes.filter(function (process) {
                return (process.getName().getValue(_this.currentLanguageId) || '').toLowerCase().indexOf(search) !== -1;
            });
        }
        else {
            this.processesFiltered = this.processes;
        }
        this.updateWorkflowList();
    };
    WorkflowProcessManagementComponent.prototype.clearValue = function (evt, input) {
        input.value = '';
        this.searchProcess = '';
        this.filterSearchUpdate();
        evt.stopPropagation();
    };
    WorkflowProcessManagementComponent.decorators = [
        { type: core_1.Component, args: [{
                    
                    selector: 'sis-workflow-process-management',
                    styles: [require('./sis-workflow-process-management.component.css')],
                    template: require('./sis-workflow-process-management.component.html')
                },] },
    ];
    /** @nocollapse */
    WorkflowProcessManagementComponent.ctorParameters = function () { return [
        { type: idm_workflow_service_client_js_1.ProcessService, },
        { type: services_1.KbService, },
        { type: idm_message_language_service_client_js_1.MessageService, },
        { type: router_1.Router, },
        { type: router_1.ActivatedRoute, },
        { type: services_1.PopUpsService, },
        { type: material_1.MatDialog, },
        { type: idm_message_language_service_client_js_1.LanguageService, },
        { type: idm_session_data_provider_api_js_1.CurrentLanguageProvider, },
        { type: core_1.ChangeDetectorRef, },
    ]; };
    WorkflowProcessManagementComponent.propDecorators = {
        "drawer": [{ type: core_1.ViewChild, args: ['drawer',] },],
    };
    WorkflowProcessManagementComponent = __decorate([
        subscription_manager_decorator_1.SubscriptionManager(),
        __metadata("design:paramtypes", [idm_workflow_service_client_js_1.ProcessService,
            services_1.KbService,
            idm_message_language_service_client_js_1.MessageService,
            router_1.Router,
            router_1.ActivatedRoute,
            services_1.PopUpsService,
            material_1.MatDialog,
            idm_message_language_service_client_js_1.LanguageService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            core_1.ChangeDetectorRef])
    ], WorkflowProcessManagementComponent);
    return WorkflowProcessManagementComponent;
}());
exports.WorkflowProcessManagementComponent = WorkflowProcessManagementComponent;
//# sourceMappingURL=sis-workflow-process-management.component.js.map